module.exports = __webpack_public_path__ + "d9f472a60330e58dacc1d0f40e61a7b9.png";